// extracted by mini-css-extract-plugin
export default {"title":"MyModal_title__IN5Vv","text":"MyModal_text__dzxKh","content":"MyModal_content__FAuvu"};